import React from "react";
import Pic1 from "./../../assets/img/SPSingh.jpg";
import Pic2 from "./../../assets/img/mahabirSingh.jpg";
import Pic3 from "./../../assets/img/bharatsingh.jpg";
import Pic4 from "./../../assets/img/SPSingh.jpg";
import Pic5 from "./../../assets/img/jaibirSingh.jpg";
import Pic6 from "./../../assets/img/rahuldeepRana.jpg";
import Pic7 from "./../../assets/img/lalet.jpg";

const RegionalOffices = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Regional Offices</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <h6>HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED</h6>

        <p>(A STATE GOVT. UNDERTAKING)</p>

        <p>BEEJ BHAWAN, BAYS 3-6, SECTOR-2, PANCHKULA</p>

        <p>PHONE : 0172-2577755</p>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th>S.No.</th>
                <th>
                  Officer Name &amp;<br></br> Officer Address
                </th>
                <th>Designation</th>
                <th>Phone Nos.</th>
                <th>Mobile No.</th>
                <th>Email</th>
                <th>Photo</th>
              </tr>
              <tr>
                <td>1</td>
                <td>
                  <p>Sh. S.P. Singh</p>

                  <p>Haryana Seeds Dev. Corp. Ltd.,</p>

                  <p>G.T. Road, Near Pipli,</p>

                  <p>Umri (Kurukshetra)</p>
                </td>
                <td>Regional Manager (Officiating)</td>
                <td>01744-230339</td>
                <td>9416388861</td>
                <td>hsdcumri@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic1} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>Sh. Mahabir Singh</p>

                  <p>Haryana Seeds Dev. Corp. Ltd.,</p>

                  <p>4th Mile Stone, Sirsa Road,</p>

                  <p>Hisar</p>
                </td>
                <td>Regional Manager (Officiating)</td>
                <td>01662-275065</td>
                <td>9813854429</td>
                <td>hsdchsrestt@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic2} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>Sh. Bharat Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>4th Mile Stone, Hisar Road,</p>

                  <p>Sirsa</p>
                </td>
                <td>Manager (Officiating)</td>
                <td>01666-243297</td>
                <td>7988651861</td>
                <td>hsdcsirsa@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic3} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <p>Sh. S.P. Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>M-5, Ind. Area,</p>

                  <p>Yamuna Nagar</p>
                </td>
                <td>Manager (Additional Charge)</td>
                <td>01732-250391</td>
                <td>9416388861</td>
                <td>hsdcynr@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic4} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <p>Sh. Jaibir Singh</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>Narhera Road</p>

                  <p>Pataudi (Gurgaon)</p>
                </td>
                <td>Manager</td>
                <td>0124-2672847</td>
                <td>9992110635</td>
                <td>hsdcptd@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic5} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  <p>Sh. Rahuldeep Rana</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>Dangra Road,</p>

                  <p>Tohana</p>
                  <p>(Fatehabad)</p>
                </td>
                <td>Manager (Officiating)</td>
                <td>01692-220879</td>
                <td>9991091214</td>
                <td>hsdc.tohana@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic6} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>

              <tr>
                <td>7</td>
                <td>
                  <p>Sh. Lalet</p>

                  <p>Haryana Seeds Dev. Corpn. Ltd.,</p>

                  <p>&nbsp;</p>

                  <p>Bhiwani</p>
                </td>
                <td>Marketing Officer (Officiating)</td>
                <td>01664-242243</td>
                <td>9467396381</td>
                <td>mohsdcbhiwani@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic7} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RegionalOffices;
